import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Home, Users, Shield, Target } from 'lucide-react';

const LoadingScreen = () => {
  const [logoError, setLogoError] = useState(false);

  // Professional service highlights
  const highlights = [
    { icon: Home, label: 'Quality' },
    { icon: Shield, label: 'Trust' },
    { icon: Target, label: 'Precision' },
    { icon: Users, label: 'Expertise' }
  ];

  return (
    <div className="fixed inset-0 bg-gray-900 z-50 flex items-center justify-center">
      <div className="text-center max-w-sm px-4">
        {/* Logo */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          {!logoError ? (
            <img 
              src="./logo.png" 
              alt="Master Home Logo" 
              className="h-16 w-auto mx-auto brightness-0 invert" 
              onError={() => setLogoError(true)}
            />
          ) : (
            <div className="h-16 w-16 mx-auto bg-gray-800 rounded-lg flex items-center justify-center">
              <span className="text-2xl font-bold text-primary-500">MH</span>
            </div>
          )}
        </motion.div>

        {/* Motto */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mb-8"
        >
          <h2 className="text-2xl font-bold text-white font-display">
            Build with Expert
          </h2>
        </motion.div>

        {/* Progress Bar */}
        <div className="relative w-full h-1 bg-gray-700 rounded-full overflow-hidden mb-8">
          <motion.div
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              repeat: Infinity
            }}
            className="absolute inset-y-0 left-0 bg-primary-600 rounded-full"
          />
        </div>

        {/* Service Highlights */}
        <div className="grid grid-cols-4 gap-4">
          {highlights.map((Item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + index * 0.1 }}
              className="flex flex-col items-center"
            >
              <Item.icon className="w-5 h-5 text-primary-500 mb-1" />
              <span className="text-xs text-gray-400">{Item.label}</span>
            </motion.div>
          ))}
        </div>

        {/* Loading Message */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: [1, 0.5, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="text-sm text-gray-400 mt-8"
        >
          Preparing your experience...
        </motion.p>
      </div>
    </div>
  );
};

export default LoadingScreen;
